import React, { Suspense } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import RoutesWrapper from './RoutesWrapper'

import Testing from '../pages/test/Testing'
import WelcomePage from '../pages/intros/Welcome'
import Intro from '../pages/intros/Intro'
import IntroRole from '../pages/intros/IntroRole'
import Fallback from '../components/loading/Fallback'

import {
  Stage1Routes,
  Stage2Routes,
  Stage3Routes,
  Stage4Routes,
  Stage5Routes,
  Stage6Routes,
} from './stages'
import EndVideo from '../pages/stages/end/EndVideo'
import Final from '../pages/stages/end/Final'

const Main = React.lazy(() => import('../pages/stages/main/Main'))
const Hints = React.lazy(() => import('../pages/hints/Hints'))
const End = React.lazy(() => import('../pages/stages/end/End'))
const Success = React.lazy(
  () => import('../pages/stages/end/Success'),
)

export default function PageRoutes() {
  const location = useLocation()

  let state = location.state as { backgroundLocation?: Location }

  return (
    <Suspense fallback={<Fallback />}>
      <div>
        <Routes location={state?.backgroundLocation || location}>
          <Route path="/ader" element={<Testing />} />

          <Route
            path="/"
            element={
              <RoutesWrapper loc="home">
                <WelcomePage />
              </RoutesWrapper>
            }
          />
          <Route
            path="/intro"
            element={
              <RoutesWrapper loc="intro">
                <Intro />
              </RoutesWrapper>
            }
          />
          <Route
            path="/introrole"
            element={
              <RoutesWrapper loc="introrole">
                <IntroRole />
              </RoutesWrapper>
            }
          />

          {Stage1Routes}
          {Stage2Routes}
          {Stage3Routes}
          {Stage4Routes}
          {Stage5Routes}
          {Stage6Routes}

          <Route
            path="/main"
            element={
              <RoutesWrapper loc="main">
                <Main />
              </RoutesWrapper>
            }
          />
          <Route path="/stage/hints" element={<Hints />} />
          <Route path="/end" element={<End />} />
          <Route path="/success" element={<Success />} />
          <Route path="endvideo" element={<EndVideo />} />
          <Route path="final" element={<Final />} />
        </Routes>

        {/* Show the modal when a `backgroundLocation` is set */}
        {/* {state?.backgroundLocation && (
          <Routes>
            <Route path="/modal/:id" element={<ModalPage />} />
          </Routes>
        )} */}
      </div>
    </Suspense>
  )
}
